import { LicenseInfo } from '@mui/x-date-pickers-pro';
import { getRuntimeConfig } from '@/lib/runtimeConfig';

function muiDatePickerLicenseInitializer() {
  const licenseKey = getRuntimeConfig().env.REACT_APP_MUI_DATEPICKER_LICENSE;
  LicenseInfo.setLicenseKey(licenseKey);
}

export default muiDatePickerLicenseInitializer;
